module.exports = __webpack_public_path__ + "img/logo.1379a76e.png";